const spacerFree = require('./spacerFree/main');
const spacerPro  = require('./spacerPro/main');
const shared     = require('./shared/main');

module.exports = {
  spacerFree,
  spacerPro,
  shared
};
